import Cookies from 'js-cookie'

export const getSessionKey = (prefix = 'session_') => {
  const localParams = location.search.replace('?', '').split('&')?.reduce((params, param) => {
    if (param.includes('=')) {
      const [key, value] = param.split('=');
      params[key] = value;
    }

    return params;
  }, {});

  return localParams?.session_key ? `${prefix}${localParams?.session_key}` : null;
}

export const setItem = (name, value, duration = null) => {
  const sessionKey = getSessionKey();
  const itemKey = sessionKey ?? name;

  if (sessionKey) {
    const sessionValue = JSON.parse(localStorage?.getItem(itemKey) ?? Cookies.get(itemKey) ?? '{}');

    if (!value) {
      value = undefined;
    }

    value = JSON.stringify({ ...sessionValue, [name]: value });
  }

  if (localStorage) {
    if (!value) {
      return localStorage.removeItem(itemKey);
    }

    return localStorage.setItem(itemKey, value);
  }

  if (!duration) {
    duration = 365;
  }

  Cookies.set(itemKey, value, { expires: duration });
}

export const getItem = (name) => {
  const sessionKey = getSessionKey();
  const itemKey = sessionKey ?? name;
  let value = localStorage?.getItem(itemKey) ?? Cookies.get(itemKey);

  if (sessionKey && value) {
    value = JSON.parse(value)?.[name] ?? null;
  }

  return value;
}

export const clearCache = () => {
  if (localStorage) {
    const sessionKey = getSessionKey();

    if (sessionKey) {
      let sessionValue = JSON.parse(localStorage?.getItem(itemKey) ?? Cookies.get(itemKey) ?? '{}');
      sessionValue = JSON.stringify(Object.fromEntries(Object.entries(sessionValue).filter(([key]) => !key.includes('_container'))));

      localStorage.setItem(sessionKey, sessionValue);
    } else {
      for (const key in localStorage) {
        if (key.includes('_container')) {
          localStorage.removeItem(key);
        }
      }
    }
  }
}
